import Alpine from "alpinejs";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

Alpine.data('StepCarousel', () => ({
    init(){
        const swiper = new Swiper(this.$el.querySelector('.stepCarousel'), {
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: this.$el.querySelector('.swiper-btn-next'),
                prevEl: this.$el.querySelector('.swiper-btn-prev'),
            },
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                bulletActiveClass: 'opacity-100',
                clickable: true,
                renderBullet: function(index, className){
                    return '<span class="w-2 h-2 opacity-30 block rounded-full bg-primary-dark ' + className + '"></span>';
                }
            },
            centerInsufficientSlides: true,
            slidesPerView: 1,
            breakpoints: {
                640: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                1024: {
                    slidesPerView: 4
                }
            }
        });
    }
}));